/**
 * Route UI della pagina "ENISA Reports" (thread di notifica SRP, CRA Art.14(2)).
 *
 * La pagina vive su /enisa-reports; le vecchie route /srp e /srp/:id restano come redirect
 * (bookmark, link nelle notifiche già inviate). Le API dell'srp-service restano su /api/srp/…:
 * qui cambiano SOLO i path del portale.
 */

/** Path della lista dei report ENISA. */
export const ENISA_REPORTS_PATH = '/enisa-reports';

/** Prefisso storico della pagina, mantenuto come redirect verso {@link ENISA_REPORTS_PATH}. */
export const LEGACY_SRP_PATH = '/srp';

/** Viste della lista: thread aperti (default), report precedenti (chiusi), tutti. */
export type ReportView = 'aperti' | 'precedenti' | 'tutti';

export const REPORT_VIEWS: readonly ReportView[] = ['aperti', 'precedenti', 'tutti'];

/** Nome del parametro di query che seleziona la vista della lista. */
export const REPORT_VIEW_PARAM = 'vista';

/** Path della lista, con la vista selezionata (la vista di default non va in URL). */
export function enisaReportsListPath(view: ReportView = 'aperti'): string {
  return view === 'aperti'
    ? ENISA_REPORTS_PATH
    : `${ENISA_REPORTS_PATH}?${REPORT_VIEW_PARAM}=${view}`;
}

/** Path del dettaglio di un report. */
export function enisaReportPath(id: number | string): string {
  return `${ENISA_REPORTS_PATH}/${id}`;
}

/**
 * Traduce un path storico /srp… nel corrispondente /enisa-reports… (query e hash inclusi).
 * Path non storici sono restituiti invariati.
 */
export function legacySrpRedirectTarget(pathname: string, search = '', hash = ''): string {
  const resto = pathname.startsWith(LEGACY_SRP_PATH)
    ? pathname.slice(LEGACY_SRP_PATH.length)
    : null;
  if (resto === null || (resto !== '' && !resto.startsWith('/'))) return pathname + search + hash;
  return ENISA_REPORTS_PATH + resto + search + hash;
}
